export default __webpack_public_path__ + "static/media/JSML.f4acd43d.png";